import React, { useState } from "react";
import { Skeleton, Box } from "@mui/material";

const LazyMap = ({ src, height = 300 }) => {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Box position="relative" width="100%" height={height}>
            {isLoading && <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />}

            <iframe
                src={src}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                    position: isLoading ? "absolute" : "relative",
                    opacity: isLoading ? 0 : 1,
                    transition: "opacity 0.3s ease-in-out",
                    borderRadius: "16px",
                }}
                onLoad={() => setIsLoading(false)}
            />
        </Box>
    );
};

export default LazyMap;
